import React from "react";
import { Helmet } from "react-helmet";

export const IMOPixel = () => {
    return (
        <Helmet>
            <script>
            {`window.bgdataLayer = window.bgdataLayer || [];
function bge(){bgdataLayer.push(arguments);}
bge('init', "904302651590873600");`}
            </script>
            <script async src="https://api.imotech.video/ad/events.js?pixel_id=904302651590873600"></script>
        </Helmet>
    );
}

export const CallIMOOnAgreeAndContinue = () => {
    window.bge('event', 'form_button', {configId: '904302651590873600'});
}

export const CallIMOOnThankYouPage = () => {
    window.bge('event', 'ec_register', {configId: '904302651590873600'});
}